import { initializeApp, getApps, getApp } from 'firebase/app';
import { initializeAuth, indexedDBLocalPersistence, browserLocalPersistence, GoogleAuthProvider } from 'firebase/auth';
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager
} from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';
import firebaseConfig from '../../firebase-applet-config.json';

// Initialize Firebase App
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

// Initialize Firebase Auth with explicit persistence and NO startup popupRedirectResolver (prevents auth/iframe.js load on startup)
export const auth = initializeAuth(app, {
  persistence: [indexedDBLocalPersistence, browserLocalPersistence]
});

export const functionsClient = getFunctions(app, 'asia-south1');

export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager()
  }),
  experimentalAutoDetectLongPolling: true
}, firebaseConfig.firestoreDatabaseId);

export const storage = getStorage(app);

let realtimeDbInstance: ReturnType<typeof getDatabase> | null = null;
export const getRealtimeDb = () => {
  if (!realtimeDbInstance) {
    const realtimeDatabaseUrl = (firebaseConfig as typeof firebaseConfig & { databaseURL?: string }).databaseURL;
    if (realtimeDatabaseUrl) {
      realtimeDbInstance = getDatabase(app, realtimeDatabaseUrl);
    }
  }
  return realtimeDbInstance;
};

export const realtimeDb = getRealtimeDb();

// Providers
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

export default app;
